import {TableColumn} from '@fl/cmsch-fe-library';

import {MaleFleckviehAnimalInList} from 'api/gen/MaleFleckviehAnimalInList';

import {
    dateColumn,
    decimalColumn,
    hyperlinkColumn,
    numberColumn,
    stringColumn,
} from '../../../user/utils/table-columns-helpers';
import {getAnimalBrowserLink} from '../../utils';

export const matingFleckviehBullsColumns: Array<TableColumn<MaleFleckviehAnimalInList>> = [
    hyperlinkColumn({
        field: 'lineRegistry',
        width: 130,
        align: 'right',
        valueToUrl: getAnimalBrowserLink,
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    }),
    stringColumn({
        field: 'name',
        width: 130,
        align: 'right',
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    }),
    stringColumn({
        field: 'earTag',
        width: 150,
        align: 'right',
        verticalName: false,
        filterTypes: [
            'betweenEarTags',
            'containsStringOr',
            {type: 'multiSelectStringOrEquals', subtype: 'bulkString'},
            'null',
        ],
    }),
    dateColumn({field: 'birthDate', width: 150, align: 'right'}),
    stringColumn({
        field: 'organizationCode',
        width: 100,
        align: 'right',
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    }),
    numberColumn({field: 'bvMilkKg', width: 100, align: 'right'}),
    numberColumn({field: 'bvFatKg', width: 80, align: 'right'}),
    decimalColumn({field: 'bvFatPercentage', width: 80, align: 'right', fixedDecimals: 2}),
    numberColumn({field: 'bvProteinKg', width: 115, align: 'right'}),
    decimalColumn({field: 'bvProteinPercentage', width: 110, align: 'right', fixedDecimals: 2}),
    numberColumn({field: 'rbvSomaticCells', width: 65, align: 'right'}),
    numberColumn({field: 'rbvClinicalMastitis', width: 65, align: 'right'}),
    numberColumn({field: 'rbvFrame', width: 65, align: 'right'}),
    numberColumn({field: 'rbvBodyDepth', width: 65, align: 'right'}),
    numberColumn({field: 'rbvBackAngle', width: 65, align: 'right'}),
    numberColumn({field: 'rbvBackWidth', width: 65, align: 'right'}),
    numberColumn({field: 'rbvRearPosture', width: 65, align: 'right'}),
    numberColumn({field: 'rbvHoovesAngle', width: 65, align: 'right'}),
    numberColumn({field: 'rbvForeUdderAttachment', width: 65, align: 'right'}),
    numberColumn({field: 'rbvFrontTeatsPlacement', width: 65, align: 'right'}),
    numberColumn({field: 'rbvTeatsLength', width: 65, align: 'right'}),
    numberColumn({field: 'rbvUdderDepth', width: 65, align: 'right'}),
    numberColumn({field: 'rbvSuspensoryLigament', width: 65, align: 'right'}),
    numberColumn({field: 'rbvRearTeatsPlacement', width: 65, align: 'right'}),
    numberColumn({field: 'rbvExtremities', width: 95, align: 'right'}),
    numberColumn({field: 'rbvUdder', width: 85, align: 'right'}),
    numberColumn({field: 'rbvLongevity', width: 85, align: 'right'}),
    numberColumn({field: 'rbvMilkability', width: 85, align: 'right'}),
    numberColumn({field: 'milkIndex', width: 65, align: 'right'}),
    numberColumn({field: 'totalBreedingValue', width: 65, align: 'right'}),
    numberColumn({field: 'rbvDailyGain', width: 65, align: 'right'}),
    numberColumn({field: 'rbvCarcassGrade', width: 65, align: 'right'}),
    numberColumn({field: 'rbvDressingPercentage', width: 65, align: 'right'}),
    numberColumn({field: 'fleshIndex', width: 65, align: 'right'}),
    numberColumn({field: 'rbvPersistence', width: 65, align: 'right'}),
    numberColumn({field: 'udderHealthIndex', width: 65, align: 'right'}),
    numberColumn({field: 'rbvPaternalCalvingEase', width: 65, align: 'right'}),
    numberColumn({field: 'rbvMaternalCalvingEase', width: 65, align: 'right'}),
    numberColumn({field: 'fertilityIndex', width: 65, align: 'right'}),
    numberColumn({field: 'rbvEarlyFertilityDisorders', width: 65, align: 'right'}),
    numberColumn({field: 'vitalityIndex', width: 65, align: 'right'}),
    numberColumn({field: 'rbvHypocalcemia', width: 65, align: 'right'}),
    numberColumn({field: 'rbvCysts', width: 65, align: 'right'}),
    numberColumn({field: 'fitnessIndex', width: 65, align: 'right'}),
    numberColumn({field: 'rbvMusculature', width: 65, align: 'right'}),
    numberColumn({field: 'rbvBackHeight', width: 65, align: 'right'}),
    numberColumn({field: 'rbvBodyLength', width: 65, align: 'right'}),
    numberColumn({field: 'rbvAnkleJoint', width: 65, align: 'right'}),
    numberColumn({field: 'rbvPastern', width: 65, align: 'right'}),
    numberColumn({field: 'rbvFrontUdderAttachmentLength', width: 65, align: 'right'}),
    numberColumn({field: 'rbvRearUdderAttachmentLength', width: 65, align: 'right'}),
    numberColumn({field: 'rbvTeatsWidth', width: 65, align: 'right'}),
    numberColumn({field: 'rbvTeatsPosition', width: 65, align: 'right'}),
    numberColumn({field: 'rbvUdderPurity', width: 65, align: 'right'}),
];
